<template>
    <div style='overflow-x:auto' >
        <table>
            <tr>
                <th v-for="column in table.columns" :key="column" v-html="column" class="text-to-uppercase"/>
            </tr>
            <tr v-for="(row, index) in table.data" :key="index">
                <td v-for="(column, indexColumn) in table.columns" :key="column" v-html="row[column].replace(/m2/g, 'm<sup>2</sup>')" :class="{'text-to-uppercase' : indexColumn === 0}"/>
            </tr>

        </table>
        <!--
        <table cellpadding=0 border=0 cellspacing=0>
            <tr>
                <td>PROCESSO</td>
                <td>TRATTAMENTI BIOLOGICI</td>
                <td>TRATTAMENTO TERMICO DI COMBUSTIONE</td>
                <td>PIROLISI</td>
                <td>ECOGAS GENERATOR</td>
            </tr>
            <tr>
                <td>MATERIALE ORGANICO TRATTATO</td>
                <td>Biomasse</td>
                <td>Biomasse; rifiuti</td>
                <td>Biomasse; rifiuti</td>
                <td>Biomasse; rifiuti</td>
            </tr>
            <tr>
                <td>DURATA DEL PROCESSO</td>
                <td>60 gg</td>
                <td>2-3 Ore</td>
                <td>2-3 Ore</td>
                <td>2-3 Ore</td>
            </tr>
            <tr>
                <td>QUANTITÀ ORARIA TRATTATA</td>
                <td>4 ton/h</td>
                <td>>12,5 ton/h</td>
                <td>1 ton/h</td>
                <td>1 ton/h</td>
            </tr>
            <tr>
                <td>SUPERFICIE IMPIANTO OCCUPATA</td>
                <td>15.000 m<sup>2</sup></td>
                <td>>30.000 m<sup>2</sup></td>
                <td>2.000 m<sup>2</sup></td>
                <td>2.000 m<sup>2</sup></td>
            </tr>
            <tr>
                <td>VALORE ECONOMICO IMPIANTO</td>
                <td>10-12 mln/Mwe</td>
                <td>12-15 mln/Mwe</td>
                <td>7-8 mln/Mwe</td>
                <td>7-8 mln/Mwe</td>
            </tr>
            <tr>
                <td>POTENZA ELETTRICA PER TONNELLATA</td>
                <td>0,25 Mwe/ton</td>
                <td>0,5 Mwe/ton</td>
                <td>0,5 Mwe/ton</td>
                <td>1 Mwe/ton</td>
            </tr>
            <tr>
                <td>RESIDUI DA PROCESSO</td>
                <td>Compost Gas di scarico motori</td>
                <td>Ceneri Fumi con polveri Pm10</td>
                <td>Ceneri e catrami Incondensabili Gas di scarico motori</td>
                <td>Inerti Gas di scarico motori</td>
            </tr>
            <tr>
                <td>COSTI DI GESTIONE</td>
                <td>Alti</td>
                <td>Alti</td>
                <td>Alti</td>
                <td>Bassi</td>
            </tr>
        </table>
        -->
    </div>
</template>

<script>
export default {
  name: 'TableSmaltimento',
  props: {
    table: {
      type: Object,
      required: true
    }
  }
}
</script>

<style lang="scss">
  @import "../assets/mixins/breakpoints";

    table{
        min-width: 100%;
        tr:nth-child(even) {
            background: #f6f6f6;
            td:last-child {
                background-color: #68b59b;
            }
        }
        tr:nth-child(odd) {
            background: #FFF;
            td:last-child {
                background-color: #30AE8D;
            }
        }
        td:first-child {
            background-color: #EAEAEA;
            font-weight: 700;
            font-size: 16px;
            @media #{$large_mq} {
                font-size: 17px;
            }
            @media #{$xlarge_mq} {
                font-size: 18px;
            }
        }
        td:last-child {
            font-weight: 700;
            letter-spacing: .05rem;
            color: #FFF;
            font-size: 16px;
            @media #{$large_mq} {
                font-size: 17px;
            }
            @media #{$xlarge_mq} {
                font-size: 18px;
            }
        }
        td{
            text-align: center;
            padding: 20px;
            letter-spacing: .035rem;
            font-size: 14px;
            @media #{$large_mq} {
                letter-spacing: .05rem;
                font-size: 15px;
            }
            @media #{$xlarge_mq} {
                font-size: 16px;
            }
        }
        th {
            font-weight: 700;
            font-size: 16px;
            padding: 20px;
            @media #{$large_mq} {
                font-size: 17px;
            }
            @media #{$xlarge_mq} {
                font-size: 18px;
            }
        }
    }

</style>
